import { lazy } from 'react';
import { ComponentType } from '../types';

const components = import.meta.glob('./*/index.{tsx,jsx}', { eager: false });
const manifests = import.meta.glob('./*/manifest.ts', { eager: true });

export type ComponentMapping = Record<
  ComponentType,
  React.LazyExoticComponent<React.ComponentType<any>>
>;

export const COMPONENT_MAPPING: ComponentMapping = Object.fromEntries(
  Object.entries(manifests).map(([path, mod]) => {
    const folder = path.split('/')[1];
    const key = (mod as any).default?.name ?? folder;
    const LazyComp = lazy(async () => {
      const mod: any = await (
        components[`./${folder}/index.tsx`] as () => Promise<any>
      )();
      return { default: mod.default };
    });
    return [key, LazyComp] as const;
  })
);
